@if (hasErrors()) {
  <div class="error-summary-box">
    <div class="error-summary-header">
      <span class="error-icon">⚠️</span>
      <h3>{{ title() }}</h3>
    </div>
    <div class="error-summary-content">
      @for (group of getErrorGroups(); track group.errorType) {
        <div class="error-group">
          <div class="error-type-label">{{ group.errorLabel }}</div>
          <ul class="error-fields-list">
            @for (fieldError of group.fieldErrors; track fieldError.fieldName) {
              <li class="error-field" (click)="focusField(fieldError.fieldName)">{{ getFieldLabel(fieldError.fieldName) }}</li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
}
